const join = ( ...args ) => {
  return args
    .filter( a => a )
    .join( ' ' )
}
export default join
